import { render } from "./AdsFilters.vue?vue&type=template&id=2e47b98a"
import script from "./AdsFilters.vue?vue&type=script&lang=js"
export * from "./AdsFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__